import { DataSource } from '../cms/DataSource';
import { FilterState, listFilterType } from '../../pages/content/listPage/FilterState';
import { ListFilters } from '../../pages/content/listPage/ListFilters';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';

const Constants = {
  filters: [listFilterType.day, listFilterType.channel, listFilterType.tag],
};
export interface FilterInit {
  channel: { text: string; value: ChannelModel };
}

export class EpgListFilterDataSource extends DataSource {
  private _init: FilterInit | undefined;
  private focusPast: boolean;
  private state: FilterState | undefined;
  constructor(backend: Backend, init = undefined, focusPast = false) {
    super(backend);
    this._init = init;
    this.focusPast = focusPast;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: ListFilters,
      data: this,
      filterState: this.state,
      backend: this.backend,
    };
  }

  /**
   * @returns {Promise<BannerDataSource>}
   */
  override load() {
    return new Promise(resolve => {
      this.state = new FilterState(this._init);
      Constants.filters.forEach(filter => {
        this.state!.add(filter);
      });
      resolve(this);
    });
  }

  override isEmpty() {
    return false;
  }

  height() {
    return 60;
  }
}
